<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal modal--wide" role="dialog" aria-modal="true" aria-labelledby="type-chooser-title">
      <div class="modal__head">
        <div>
          <h2 id="type-chooser-title" class="modal__title">יצירת לינקטון חדש</h2>
          <p class="modal__sub">
            בחרו את סוג הלינקטון שאתם רוצים ליצור.
            <strong>אין צורך לשלם כעת</strong> — התשלום מתבצע רק כשתבחרו לשלוח לאישור.
          </p>
        </div>
        <button type="button" class="modal__close" aria-label="סגירה" @click="$emit('close')">
          <LtIcon name="close" :size="18" />
        </button>
      </div>

      <div class="modal__body">
        <div class="type-grid">
          <button
            v-for="(t, key) in types"
            :key="key"
            type="button"
            class="type-card"
            :class="{ 'is-popular': key === 'ep' }"
            @click="$emit('choose', key)"
          >
            <div class="type-card__icon"><LtIcon :name="t.icon" :size="22" /></div>
            <div class="type-card__name">{{ t.name }}</div>
            <div class="type-card__meta">
              {{ key === 'single' ? 'רצועה אחת' : 'עד ' + t.trackLimit + ' רצועות' }}
            </div>
            <div class="type-card__price">
              ₪{{ formatPrice(t.price) }}<small>בעת שליחה לאישור</small>
            </div>
            <div v-if="balance[key] > 0" class="type-card__use-bal">
              <LtIcon name="wallet" :size="12" />
              זמין ביתרה: {{ balance[key] }} — לא נדרש תשלום
            </div>
          </button>
        </div>

        <div class="bundle-callout">
          <div class="bundle-callout__lead">
            <div class="bundle-callout__icon">
              <LtIcon name="package" :size="20" />
            </div>
            <div class="bundle-callout__text">
              <strong>מארז 3 לינקטונים</strong> רגילים — ₪2,850.<br>
              שווה במיוחד אם אתם מתכננים יותר מסינגל אחד. הרכישה לא חובה כעת.
            </div>
          </div>
          <button type="button" class="btn btn--soft" @click="$emit('buy-packages')">לפרטים על המארזים</button>
        </div>
      </div>

      <div class="modal__foot modal__foot--end">
        <button type="button" class="btn btn--ghost" @click="$emit('close')">ביטול</button>
      </div>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import { LINKTONE_TYPES } from './data.js';

export default {
  name: 'TypeChooserModal',
  components: { LtIcon },
  props: {
    balance: { type: Object, required: true },
  },
  emits: ['close', 'choose', 'buy-packages'],
  computed: {
    types() {
      return LINKTONE_TYPES;
    },
  },
  methods: {
    formatPrice(price) {
      return Number(price).toLocaleString('he-IL');
    },
  },
};
</script>
